import { render, staticRenderFns } from "./shandong_push.vue?vue&type=template&id=70e7f86c&scoped=true&"
import script from "./shandong_push.vue?vue&type=script&lang=js&"
export * from "./shandong_push.vue?vue&type=script&lang=js&"
import style0 from "./shandong_push.vue?vue&type=style&index=0&id=70e7f86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7f86c",
  null
  
)

export default component.exports